import queryString from 'query-string'
import routeParams from 'helpers/routeParams'
import moment from 'moment'

const ASSESSOR_API_CALL = 'dofe-bo/ASSESSORS/ASSESSOR_API_CALL'
const ASSESSOR_API_CALL_SUCCESS = 'dofe-bo/ASSESSORS/ASSESSOR_API_CALL_SUCCESS'
const ASSESSOR_API_CALL_FAIL = 'dofe-bo/ASSESSORS/ASSESSOR_API_CALL_FAIL'

const CRUD_ASSESSOR = 'dofe-bo/ASSESSORS/CRUD_ASSESSOR'
const CRUD_ASSESSOR_SUCCESS = 'dofe-bo/ASSESSORS/CRUD_ASSESSOR_SUCCESS'
const CRUD_ASSESSOR_FAIL = 'dofe-bo/ASSESSORS/CRUD_ASSESSOR_FAIL'

const GET_ASSESSORS = 'dofe-bo/ASSESSORS/GET_ASSESSORS'
const GET_ASSESSORS_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSORS_SUCCESS'
const GET_ASSESSORS_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSORS_FAIL'

const GET_ORGANIZATION_ASSESSORS = 'dofe-bo/ASSESSORS/GET_ORGANIZATION_ASSESSORS'
const GET_ORGANIZATION_ASSESSORS_SUCCESS = 'dofe-bo/ASSESSORS/GET_ORGANIZATION_ASSESSORS_SUCCESS'
const GET_ORGANIZATION_ASSESSORS_FAIL = 'dofe-bo/ASSESSORS/GET_ORGANIZATION_ASSESSORS_FAIL'


const GET_ASSESSORS_DETAIL = 'dofe-bo/ASSESSORS/GET_ASSESSORS_DETAIL'
const GET_ASSESSORS_DETAIL_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSORS_DETAIL_SUCCESS'
const GET_ASSESSORS_DETAIL_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSORS_DETAIL_FAIL'

const GET_ASSESSOR = 'dofe-bo/ASSESSORS/GET_ASSESSOR'
const GET_ASSESSOR_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSOR_SUCCESS'
const GET_ASSESSOR_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSOR_FAIL'

const GET_ASSESSOR_OVERVIEW = 'dofe-bo/ASSESSORS/GET_ASSESSOR_OVERVIEW'
const GET_ASSESSOR_OVERVIEW_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSOR_OVERVIEW_SUCCESS'
const GET_ASSESSOR_OVERVIEW_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSOR_OVERVIEW_FAIL'

const GET_ASSESSOR_LIST = 'dofe-bo/ASSESSORS/GET_ASSESSOR_LIST'
const GET_ASSESSOR_LIST_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSOR_LIST_SUCCESS'
const GET_ASSESSOR_LIST_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSOR_LIST_FAIL'

const SET_FILTER = 'dofe-bo/ASSESSORS/SET_FILTER'
const SET_REG_FILTER = 'dofe-bo/ASSESSORS/SET_REG_FILTER'
const SET_ACT_FILTER = 'dofe-bo/ASSESSORS/SET_ACT_FILTER'
const SET_PARAMS = 'dofe-bo/ASSESSORS/SET_PARAMS'
const SET_REG_PARAMS = 'dofe-bo/ASSESSORS/SET_REG_PARAMS'
const SET_ACT_PARAMS = 'dofe-bo/ASSESSORS/SET_ACT_PARAMS'

const GET_AVAILABLE_ASSESSORS = 'dofe-bo/ASSESSORS/GET_AVAILABLE_ASSESSORS'
const GET_AVAILABLE_ASSESSORS_SUCCESS = 'dofe-bo/ASSESSORS/GET_AVAILABLE_ASSESSORS_SUCCESS'
const GET_AVAILABLE_ASSESSORS_FAIL = 'dofe-bo/ASSESSORS/GET_AVAILABLE_ASSESSORS_FAIL'

const GET_ASSESSOR_AFFILIATIONS_OVERVIEW = 'dofe-bo/ASSESSORS/GET_ASSESSOR_AFFILIATIONS_OVERVIEW'
const GET_ASSESSOR_AFFILIATIONS_OVERVIEW_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSOR_AFFILIATIONS_OVERVIEW_SUCCESS'
const GET_ASSESSOR_AFFILIATIONS_OVERVIEW_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSOR_AFFILIATIONS_OVERVIEW_FAIL'

const GET_ASSESSOR_ACT_CAT_REGISTRATION = 'dofe-bo/ASSESSORS/GET_ASSESSOR_ACT_CAT_REGISTRATION'
const GET_ASSESSOR_ACT_CAT_REGISTRATION_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSOR_ACT_CAT_REGISTRATION_SUCCESS'
const GET_ASSESSOR_ACT_CAT_REGISTRATION_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSOR_ACT_CAT_REGISTRATION_FAIL'

const GET_ASSESSOR_FILES = 'dofe-bo/ASSESSORS/GET_ASSESSOR_FILES'
const GET_ASSESSOR_FILES_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSOR_FILES_SUCCESS'
const GET_ASSESSOR_FILES_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSOR_FILES_FAIL'

const GET_ASSESSOR_WWC_FILE = 'dofe-bo/ASSESSORS/GET_ASSESSOR_WWC_FILE'
const GET_ASSESSOR_WWC_FILE_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSOR_WWC_FILE_SUCCESS'
const GET_ASSESSOR_WWC_FILE_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSOR_WWC_FILE_FAIL'

const DELETE_ASSESSOR_ACTIVITY = 'dofe-bo/ASSESSORS/DELETE_ASSESSOR_ACTIVITY'
const DELETE_ASSESSOR_ACTIVITY_SUCCESS = 'dofe-bo/ASSESSORS/DELETE_ASSESSOR_ACTIVITY_SUCCESS'
const DELETE_ASSESSOR_ACTIVITY_FAIL = 'dofe-bo/ASSESSORS/DELETE_ASSESSOR_ACTIVITY_FAIL'

const INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY = 'dofe-bo/ASSESSORS/INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY'
const INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY_SUCCESS = 'dofe-bo/ASSESSORS/INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY_SUCCESS'
const INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY_FAIL = 'dofe-bo/ASSESSORS/INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY_FAIL'

const INVITE_NEW_ASSESSOR = 'dofe-bo/ASSESSORS/INVITE_NEW_ASSESSOR'
const INVITE_NEW_ASSESSOR_SUCCESS = 'dofe-bo/ASSESSORS/INVITE_NEW_ASSESSOR_SUCCESS'
const INVITE_NEW_ASSESSOR_FAIL = 'dofe-bo/ASSESSORS/INVITE_NEW_ASSESSOR_FAIL'

const RESEND_INVITATION = 'dofe-bo/ASSESSORS/RESEND_INVITATION'
const RESEND_INVITATION_SUCCESS = 'dofe-bo/ASSESSORS/RESEND_INVITATION_SUCCESS'
const RESEND_INVITATION_FAIL = 'dofe-bo/ASSESSORS/RESEND_INVITATION_FAIL'

const GET_ASSESSED_ACTIVITIES = 'dofe-bo/ASSESSORS/GET_ASSESSED_ACTIVITIES'
const GET_ASSESSED_ACTIVITIES_SUCCESS = 'dofe-bo/ASSESSORS/GET_ASSESSED_ACTIVITIES_SUCCESS'
const GET_ASSESSED_ACTIVITIES_FAIL = 'dofe-bo/ASSESSORS/GET_ASSESSED_ACTIVITIES_FAIL'

const REVOKE_ACCESS = 'dofe-bo/ASSESSORS/REVOKE_ACCESS'
const REVOKE_ACCESS_SUCCESS = 'dofe-bo/ASSESSORS/REVOKE_ACCESS_SUCCESS'
const REVOKE_ACCESS_FAIL = 'dofe-bo/ASSESSORS/REVOKE_ACCESS_FAIL'

const GET_ACTIVITY_CATEGORY_REG_FILE_LIST = 'dofe-bo/ASSESSORS/GET_ACTIVITY_CATEGORY_REG_FILE_LIST'
const GET_ACTIVITY_CATEGORY_REG_FILE_LIST_SUCCESS = 'dofe-bo/ASSESSORS/GET_ACTIVITY_CATEGORY_REG_FILE_LIST_SUCCESS'
const GET_ACTIVITY_CATEGORY_REG_FILE_LIST_FAIL = 'dofe-bo/ASSESSORS/GET_ACTIVITY_CATEGORY_REG_FILE_LIST_FAIL'

const REMIND_EXPIRED_WWC = 'dofe-bo/assessorTasks/REMIND_EXPIRED_WWC'
const REMIND_EXPIRED_WWC_SUCCESS = 'dofe-bo/assessorTasks/REMIND_EXPIRED_WWC_SUCCESS'
const REMIND_EXPIRED_WWC_FAIL = 'dofe-bo/assessorTasks/REMIND_EXPIRED_WWC_FAIL'

const initialState = {
  list: [],
  detail: {},
  assessors: {
    detail: {},
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    loading: false,
    loaded: false

  },
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  loading: false,
  loaded: false,
  files: {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    loading: false,
    loaded: false,
    invalidate: null
  },
  wwcFile: {
    data: {},
    loading: false,
    loaded: false,
  },
  affiliationsOverview: {
    data: [],
    loading: false,
    loaded: false
  },
  overview: {
    data: {},
    loading: false,
    loaded: false
  },
  registrations: {
    list: [],
    files: {
      list: [],
      sort: '',
      offset: 0,
      limit: 20,
      pages: 1,
      count: null,
      filter: '',
      loading: false,
      loaded: false,
      invalidate: null
    },
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    loading: false,
    loaded: false,
    invalidate: null
  },
  activities: {
    list: [],
    sort: '',
    offset: 0,
    limit: 50,
    pages: 1,
    count: null,
    filter: '',
    loading: false,
    loaded: false,
    invalidate: null
  }
}

/* eslint complexity: 0 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ASSESSORS:
      return {
        ...state,
        loading: true
      }
    case GET_ASSESSORS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: Number(action.headers['x-total-count']),
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_ASSESSORS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ORGANIZATION_ASSESSORS:
      return {
        ...state,
        loading: true
      }
    case GET_ORGANIZATION_ASSESSORS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: Number(action.headers['x-total-count']),
        pages: Math.ceil(
            Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_ORGANIZATION_ASSESSORS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ASSESSORS_DETAIL:
      return {
        ...state,
        loading: true
      }
    case GET_ASSESSORS_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case GET_ASSESSORS_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ASSESSOR:
      return {
        ...state,
        assessors: {
          ...state.assessors,
          loading: true
        }
      }
    case GET_ASSESSOR_SUCCESS:
      return {
        ...state,
        assessors: {
          ...state.assessors,
          detail: action.result,
          loading: false,
          loaded: true,
        }
      }
    case GET_ASSESSOR_FAIL:
      return {
        ...state,
        assessors: {
          ...state.assessors,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case GET_ASSESSOR_OVERVIEW:
      return {
        ...state,
        overview: {
          ...state.overview,
          loading: true
        }
      }
    case GET_ASSESSOR_OVERVIEW_SUCCESS:
      return {
        ...state,
        overview: {
          ...state.overview,
          loading: false,
          loaded: true,
          error: null,
          data: action.result
        }
      }
    case GET_ASSESSOR_OVERVIEW_FAIL:
      return {
        ...state,
        overview: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case GET_ASSESSOR_LIST:
      return {
        ...state,
        assessors: {
          ...state.assessors,
          loading: true
        }
      }
    case GET_ASSESSOR_LIST_SUCCESS:
      return {
        ...state,
        assessors: {
          ...state.assessors,
          list: action.result,
          loading: false,
          loaded: true,
        }
      }
    case GET_ASSESSOR_LIST_FAIL:
      return {
        ...state,
        assessors: {
          ...state.assessors,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case GET_AVAILABLE_ASSESSORS:
      return {
        ...state,
        loading: true
      }
    case GET_AVAILABLE_ASSESSORS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result || [],
        count: Number(action.headers['x-total-count']),
        pages: Math.ceil(
            Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_AVAILABLE_ASSESSORS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        offset: 0
      })
    case SET_REG_FILTER:
      return {
        ...initialState,
        ...state,
        registrations: {
          ...state.registrations,
          filter: action.filterBy,
          offset: 0,
          invalidate: new Date().getTime()
        }
      }
    case SET_ACT_FILTER:
      return {
        ...initialState,
        ...state,
        activities: {
          ...state.activities,
          filter: action.filterBy,
          offset: 0,
          invalidate: new Date().getTime()
        }
      }
    case SET_PARAMS:
      return {
        ...state,
        limit: action.options.limit !== undefined
          ? action.options.limit
          : state.limit,
        offset: action.options.offset !== undefined
          ? action.options.offset
          : state.offset,
        filter: action.options.filter !== undefined
          ? action.options.filter
          : state.filter,
        sort: action.options.sort !== undefined
          ? action.options.sort
          : state.sort
      }
    case SET_REG_PARAMS:
      return {
        ...state,
        registrations: {
          ...state.registrations,
          limit: action.options.limit !== undefined
              ? action.options.limit
              : state.limit,
          offset: action.options.offset !== undefined
              ? action.options.offset
              : state.offset,
          filter: action.options.filter !== undefined
              ? action.options.filter
              : state.filter,
          sort: action.options.sort !== undefined
              ? action.options.sort
              : state.sort
        }
      }
    case SET_ACT_PARAMS:
      return {
        ...state,
        activities: {
          ...state.activities,
          limit: action.options.limit !== undefined
              ? action.options.limit
              : state.activities.limit,
          offset: action.options.offset !== undefined
              ? action.options.offset
              : state.activities.offset,
          filter: action.options.filter !== undefined
              ? action.options.filter
              : state.activities.filter,
          sort: action.options.sort !== undefined
              ? action.options.sort
              : state.activities.sort
        }
        }

    case GET_ASSESSOR_AFFILIATIONS_OVERVIEW:
      return {
        ...state,
        affiliationsOverview: {
          ...state.affiliationsOverview,
          loading: true
        }
      }
    case GET_ASSESSOR_AFFILIATIONS_OVERVIEW_SUCCESS:
      return {
        ...state,
        affiliationsOverview: {
          ...state.affiliationsOverview,
          loading: false,
          loaded: true,
          error: null,
          data: action.result
        }
      }
    case GET_ASSESSOR_AFFILIATIONS_OVERVIEW_FAIL:
      return {
        ...state,
        affiliationsOverview: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case DELETE_ASSESSOR_ACTIVITY:
      return {
        ...state,
        loading: true
      }
    case DELETE_ASSESSOR_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case DELETE_ASSESSOR_ACTIVITY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY:
      return {
        ...state,
        loading: true
      }
    case INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case INVITE_NEW_ASSESSOR:
      return {
        ...state,
        loading: true
      }
    case INVITE_NEW_ASSESSOR_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case INVITE_NEW_ASSESSOR_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ASSESSOR_ACT_CAT_REGISTRATION:
      return {
        ...state,
        registrations: {
          ...state.registrations,
          loading: true
        }
      }
    case GET_ASSESSOR_ACT_CAT_REGISTRATION_SUCCESS:
      return {
        ...state,
        registrations: {
          ...state.registrations,
          loading: false,
          loaded: true,
          error: null,
          list: action.result,
          count: Number(action.headers['x-total-count']),
          pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
        }
      }
    case GET_ASSESSOR_ACT_CAT_REGISTRATION_FAIL:
      return {
        ...state,
        registrations: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case GET_ASSESSOR_FILES:
      return {
        ...state,
        files: {
          ...state.files,
          loading: true
        }
      }
    case GET_ASSESSOR_FILES_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null,
          list: action.result,
          count: Number(action.headers['x-total-count']),
          pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
        }
      }
    case GET_ASSESSOR_FILES_FAIL:
      return {
        ...state,
        files: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case RESEND_INVITATION:
      return {
        ...state,
        loading: true
      }
    case RESEND_INVITATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case RESEND_INVITATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case REVOKE_ACCESS:
      return {
        ...state,
        loading: true
      }
    case REVOKE_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case REVOKE_ACCESS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ASSESSED_ACTIVITIES:
      return {
        ...state,
        activities: {
          ...state.activities,
          loading: true
        }
      }
    case GET_ASSESSED_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activities: {
          ...state.activities,
          loading: false,
          loaded: true,
          error: null,
          list: action.result,
          count: Number(action.headers['x-total-count']),
          pages: Math.ceil(Number(action.headers['x-total-count']) / state.activities.limit) || state.activities.pages
        }
      }
    case GET_ASSESSED_ACTIVITIES_FAIL:
      return {
        ...state,
        activities: {
          ...state.activities,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case GET_ASSESSOR_WWC_FILE:
      return {
        ...state,
        wwcFile: {
          loading: true
        }
      }
    case GET_ASSESSOR_WWC_FILE_SUCCESS:
      return {
        ...state,
        wwcFile: {
          data: action.result,
          loading: false,
          loaded: true,
          error: null,
        }
      }
    case GET_ASSESSOR_WWC_FILE_FAIL:
      return {
        ...state,
        wwcFile: {
          ...state.logs,
          data: {},
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case GET_ACTIVITY_CATEGORY_REG_FILE_LIST:
      return {
        ...state,
        registrations: {
          ...state.registrations,
          files: {
            loading: true
          }
        }
      }
    case GET_ACTIVITY_CATEGORY_REG_FILE_LIST_SUCCESS:
      return {
        ...initialState,
        ...state,
        registrations: {
          ...state.registrations,
          files:{
            ...state.files,
            loading: false,
            loaded: true,
            error: null,
            list: action.result,
            count: Number(action.headers['x-total-count']),
            pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
          }
        }
      }
    case GET_ACTIVITY_CATEGORY_REG_FILE_LIST_FAIL:
      return {
        ...state,
        registrations: {
          ...state.registrations,
          files: {
            ...state.files,
            list: [],
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      }
    case REMIND_EXPIRED_WWC:
      return {
        ...state,
        loading: true
      }
    case REMIND_EXPIRED_WWC_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case REMIND_EXPIRED_WWC_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function getAssessors(
  params = {},
  baseFilter,
  { disableQueryFilter, orgId } = {}
) {
  const queryParams = disableQueryFilter ? {} : params

  return {
    types: [
      GET_ASSESSORS,
      GET_ASSESSORS_SUCCESS,
      GET_ASSESSORS_FAIL
    ],
    promise: client =>
      client.get(
        `api/organizations/${orgId}/assessors?with=PERSON,ASSESSOR_DETAILS,ORGANIZATION&includeChildOrganizations=true${routeParams(queryParams, baseFilter)}`
      )
  }
}

export function getOrganizationAssessors(
    params = {},
    baseFilter,
    { disableQueryFilter, orgId } = {}
) {
  const queryParams = disableQueryFilter ? {} : params

  return {
    types: [
      GET_ORGANIZATION_ASSESSORS,
      GET_ORGANIZATION_ASSESSORS_SUCCESS,
      GET_ORGANIZATION_ASSESSORS_FAIL
    ],
    promise: client =>
        client.get(
            `api/assessors/organization/${orgId}/list?${routeParams(queryParams, baseFilter)}`
        )
  }
}

export function getAssessorDetail({ orgId, assessorId } = {}) {
  return {
    types: [
      GET_ASSESSORS_DETAIL,
      GET_ASSESSORS_DETAIL_SUCCESS,
      GET_ASSESSORS_DETAIL_FAIL
    ],
    promise: client =>
      client.get(
        `api/organizations/${orgId}/assessors/${assessorId}?with=PERSON,ASSESSOR_DETAILS,ORGANIZATION,ACTIVE_PARTICIPANTS_OF_ASSESSOR,ORGANIZATION_CONTACTS,ADDRESS&includeChildOrganizations=true`
      )
  }
}

export function getAccountRegistrations(params = {}, filter, { disableQueryFilter } = {}) {
  const queryParams = disableQueryFilter ? {} : params

  const withParams = ''

  return {
    types: [GET_ASSESSORS, GET_ASSESSORS_SUCCESS, GET_ASSESSORS_FAIL],
    promise: client => client.get(`api/assessor-registrations/list?with=${withParams}${routeParams(queryParams, filter)}`)
  }
}

export function getAssessorsActivityCategoryRegistrations(params = {}, filter, { disableQueryFilter } = {}) {
  const queryParams = disableQueryFilter ? {} : params

  const withParams = 'PERSON,ACTIVITY,ACTIVITY_CATEGORY,ADVENTUROUS_JOURNEY,RESIDENTIAL_PROJECT'

  return {
    types: [GET_ASSESSOR_ACT_CAT_REGISTRATION, GET_ASSESSOR_ACT_CAT_REGISTRATION_SUCCESS, GET_ASSESSOR_ACT_CAT_REGISTRATION_FAIL],
    promise: client => client.get(`api/assessor-activity-category-registrations/list?with=${withParams}${routeParams(queryParams, filter)}`)
  }
}

export function getAssessor(personId, orgId) {
  return {
    types: [
      GET_ASSESSOR,
      GET_ASSESSOR_SUCCESS,
      GET_ASSESSOR_FAIL
    ],
    promise: client => client.get(`api/assessors/${personId}/organization/${orgId}/get?with=PERSON,ASSESSOR_DETAILS,PERSON_ADDRESS`)
  }
}

export function getAssessorDetailOverview(personId, orgId) {
  return {
    types: [
      GET_ASSESSOR_OVERVIEW,
      GET_ASSESSOR_OVERVIEW_SUCCESS,
      GET_ASSESSOR_OVERVIEW_FAIL
    ],
    promise: client => client.get(`api/assessors/${personId}/organization/${orgId}/overview/get`)
  }
}

export function getAssessorList(personId) {
  return {
    types: [
      GET_ASSESSOR_LIST,
      GET_ASSESSOR_LIST_SUCCESS,
      GET_ASSESSOR_LIST_FAIL
    ],
    promise: client => client.get(`api/assessors/${personId}/list`)
  }
}

export function inviteAssessor(orgId, data) {
  return {
    types: [
      ASSESSOR_API_CALL,
      ASSESSOR_API_CALL_SUCCESS,
      ASSESSOR_API_CALL_FAIL
    ],
    promise: client =>
      client.post(`api/organizations/${orgId}/assessors`, {
        data
      })
  }
}

export function updateAssessor(organizationId, assessorId, data = {}) {
  return {
    types: [CRUD_ASSESSOR, CRUD_ASSESSOR_SUCCESS, CRUD_ASSESSOR_FAIL],
    promise: client =>
      client.put(
        `api/organizations/${organizationId}/assessors/${assessorId}?update=PERSON,ASSESSOR_DETAILS,ADDRESS`,
        {
          data
        }
      )
  }
}

export function deleteAssessor(id, { reason } = {}) {
  const reasonQuery = reason ? `?reason=${reason}` : ''

  return {
    types: [CRUD_ASSESSOR, CRUD_ASSESSOR_SUCCESS, CRUD_ASSESSOR_FAIL],
    promise: client =>
      client.del(`api/organization-contacts/${id}${reasonQuery}`)
  }
}

export function setFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setRegistrationFilter(filterBy) {
  return {
    type: SET_REG_FILTER,
    filterBy
  }
}

export function setActivitiesFilter(filterBy) {
  return {
    type: SET_ACT_FILTER,
    filterBy
  }
}


export function setAssessorsParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function setAssessorsRegistrationParams(options) {
  return {
    type: SET_REG_PARAMS,
    options
  }
}

export function setAssessorsActivityParams(options) {
  return {
    type: SET_ACT_PARAMS,
    options
  }
}


export function getAvailableAssessorsForActivityCategory(orgId, activityCategoryId) {
  return {
    types: [GET_AVAILABLE_ASSESSORS, GET_AVAILABLE_ASSESSORS_SUCCESS, GET_AVAILABLE_ASSESSORS_FAIL],
    promise: client =>
        client.get(`api/assessors/organizations/${orgId}/activity-category/${activityCategoryId}?` + queryString.stringify({ showOnlyPublic: false }), { removeToken: true })
  }
}

export function getAssessorOverview(personId) {
  return {
    types: [GET_ASSESSOR_AFFILIATIONS_OVERVIEW, GET_ASSESSOR_AFFILIATIONS_OVERVIEW_SUCCESS, GET_ASSESSOR_AFFILIATIONS_OVERVIEW_FAIL],
    promise: client =>
        client.get(`api/assessors/${personId}/affiliations-overview`, {})
  }
}

export function deleteAssessorActivity(id) {
  return {
    types: [DELETE_ASSESSOR_ACTIVITY, DELETE_ASSESSOR_ACTIVITY_SUCCESS, DELETE_ASSESSOR_ACTIVITY_FAIL],
    promise: client =>
        client.del(`api/assessor-activity-category/${id}/delete`, {})
  }
}

export function inviteAssessorToActivityCategory(personId, data) {
  return {
    types: [INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY, INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY_SUCCESS, INVITE_ASSESSOR_TO_ACTIVITY_CATEGORY_FAIL],
    promise: client =>
        client.post(`api/assessor-activity-category-registrations/assessor/${personId}/invitation`, { data })
  }
}

export function inviteNewAssessor(data) {
  return {
    types: [INVITE_NEW_ASSESSOR, INVITE_NEW_ASSESSOR_SUCCESS, INVITE_NEW_ASSESSOR_FAIL],
    promise: client =>
        client.post('api/assessor-registrations/invitation', { data })
  }
}

export function getAssessorFiles(personId, orgId) {
  return {
    types: [GET_ASSESSOR_FILES, GET_ASSESSOR_FILES_SUCCESS, GET_ASSESSOR_FILES_FAIL],
    promise: client =>
        client.get(`api/assessor-files/assessor/${personId}/organization/${orgId}/list?with=AUTHOR,ACTIVITY_CATEGORY`, {})
  }
}

export function resendAssessorRegistration(id) {
  return {
    types: [RESEND_INVITATION, RESEND_INVITATION_SUCCESS, RESEND_INVITATION_FAIL],
    promise: client =>
        client.post(`api/assessor-registrations/${id}/resend-invitation`, {})
  }
}

export function resendAssessorActivityCategoryRegistration(id) {
  return {
    types: [RESEND_INVITATION, RESEND_INVITATION_SUCCESS, RESEND_INVITATION_FAIL],
    promise: client =>
        client.post(`api/assessor-activity-category-registrations/${id}/resend-invitation`, {})
  }
}

export function getActivityCategoryRegistrationFiles(id) {
  return {
    types: [GET_ACTIVITY_CATEGORY_REG_FILE_LIST, GET_ACTIVITY_CATEGORY_REG_FILE_LIST_SUCCESS, GET_ACTIVITY_CATEGORY_REG_FILE_LIST_FAIL],
    promise: client =>
        client.get(`api/assessor-files/assessor-activity-category-registrations/${id}/list`, {})
  }
}


export function resendBecomeAssessor(personId, orgId, activityId) {
  return {
    types: [RESEND_INVITATION, RESEND_INVITATION_SUCCESS, RESEND_INVITATION_FAIL],
    promise: client =>
        client.post(`api/assessors/${personId}/organization/${orgId}/activity/${activityId}/resend-become-assessor`, {})
  }
}

export function getAssessedActivityList(params = {}, filter, queryParams, { withTs } = {}, data) {
  const ts = withTs ? `&ts=${moment().unix()}` : ''

  const readParams = 'AWARD,ASSESSOR,ACTIVITY_CATEGORY,POST_LOAD_DATE,PARTICIPANT_DETAILS'

  return {
    types: [GET_ASSESSED_ACTIVITIES, GET_ASSESSED_ACTIVITIES_SUCCESS, GET_ASSESSED_ACTIVITIES_FAIL],
    promise: client => client.post(`api/assessors/assessed-activity/list?with=${readParams}${routeParams(params, filter)}${ts}`, data = { data })
  }
}

export function getAssessorWWCFile(regId) {
  return {
    types: [GET_ASSESSOR_WWC_FILE, GET_ASSESSOR_WWC_FILE_SUCCESS, GET_ASSESSOR_WWC_FILE_FAIL],
    promise: client =>
        client.get(`api/assessor-files/wwc/assessor-registration/${regId}`, {})
  }
}

export function revokeAccess(personId, orgId) {
  return {
    types: [REVOKE_ACCESS, REVOKE_ACCESS_SUCCESS, REVOKE_ACCESS_FAIL],
    promise: client =>
        client.post(`api/assessors/${personId}/organization/${orgId}/revoke-access`, {})
  }
}

export const remindExpiredWWC = (assessorId, data) => {
  return {
    types: [
      REMIND_EXPIRED_WWC,
      REMIND_EXPIRED_WWC_SUCCESS,
      REMIND_EXPIRED_WWC_FAIL
    ],
    promise: client =>
      client.post(
        `api/assessors/wwc/assessor/${assessorId}/remind`,
        { data }
      )
  }
}
